import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseDoorsIcon } from 'assets/images/autos/icon-doors.svg';
import { ReactComponent as BaseAirConditionedIcon } from 'assets/images/autos/icon-freeze.svg';
import { ReactComponent as BaseMaxPaxIcon } from 'assets/images/autos/icon-person.svg';
import { ReactComponent as BaseTransmissionIcon } from 'assets/images/autos/icon-transmission.svg';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  width: 100%;
  flex-wrap: wrap;

  @media ${({ theme }) => theme.device.mobile} {
    position: sticky;
    top: 80px;
    background: ${ColorPalette.HEX.Lotion};
    z-index: 1;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0 16px;
    max-width: 966px;
    margin: 0 auto 8px;
    min-height: 50px;
  }

  &:empty {
    display: none;
  }

  &::after {
    content: '';
    min-width: 1px;
    min-height: 1px;
  }
`;

export const Icon: any = styled.span``;

Icon.Transmission = styled(BaseTransmissionIcon)`
  color: ${ColorPalette.HEX.White};
  height: 14px;
  margin-right: 5px;
`;

Icon.MaxPax = styled(BaseMaxPaxIcon)`
  color: ${ColorPalette.HEX.White};
  height: 14px;
  margin-right: 5px;
`;

Icon.Doors = styled(BaseDoorsIcon)`
  color: ${ColorPalette.HEX.White};
  height: 14px;
  margin-right: 5px;
`;

Icon.AirConditioned = styled(BaseAirConditionedIcon)`
  color: ${ColorPalette.HEX.White};
  height: 14px;
  margin-right: 5px;
`;

export const Label = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${ColorPalette.HEX.White};
  font-size: 12px;
`;
